import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly _messageService = inject(MessageService);
  private readonly _translate = inject(TranslateService);

  public Error(
    detail: string,
    summary: string = this._translate.instant('snackbar.error'),
    duration: number = 4000,
  ): void {
    this._messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: duration,
    });
  }

  public Warning(summary: string, duration: number = 4000): void {
    this._messageService.add({ severity: 'warn', summary: summary, life: duration });
  }

  public Success(summary: string, duration: number = 4000): void {
    this._messageService.add({ severity: 'success', summary: summary, life: duration });
  }

  public Saved(duration: number = 2000): void {
    this._messageService.add({
      severity: 'success',
      summary: this._translate.instant('snackbar.saved'),
      life: duration,
    });
  }

  public Deleted(duration: number = 2000): void {
    this._messageService.add({
      severity: 'success',
      summary: this._translate.instant('snackbar.deleted'),
      life: duration,
    });
  }
}
